import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatCrane } from "../../../models/CatCrane";
import { useCraneContext } from "../CraneContext";
import { CheckboxRenderer } from "@/controls/ag-grid/components/CheckboxRenderer";

type Props = {
  setCrane: (crane: CatCrane) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setCrane,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCraneContext();

  const rows: CatCrane[] =
    state.cranes?.map((crane: CatCrane) => ({
      ...crane,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "Name",
      headerName: "Name",
      flex: 1,
      filter: false,
    },
    {
      field: "OperatorName",
      headerName: "Operator",
      flex: 1,
      filter: false,
    },
    {
      field: "IsActive",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
    },
    // {
    //   field: "-",
    //   cellRenderer: GridButtonsV2,
    //   cellRendererParams: (params: ICellRendererParams) => ({
    //     setData: setCrane,
    //     data: params.data as CatCrane,
    //     setShowModal: setShowModal,
    //     showContextMenu: () =>
    //       showContextMenu(event, params.data, "craneContext"),
    //   }),

    //   headerName: "",
    //   sortable: false,
    //   filter: false,
    // },
  ];
  return { rows, columnDefs };
};
